import { logError } from '@modernloop/shared/utils';

import { TaskFlagType } from 'src/generated/mloop-graphql';

const TASK_FLAG_TRANSLATION_KEYS = {
  [TaskFlagType.CandidateDeclined]: 'hiring-dashboard-tasks:tasks.flag.candidateDeclined',
  [TaskFlagType.CandidateTentative]: 'hiring-dashboard-tasks:tasks.flag.candidateTentative',
  [TaskFlagType.DebriefAttendeeDeactivated]: 'hiring-dashboard-tasks:tasks.flag.debriefAttendeeDeactivated',
  [TaskFlagType.DebriefAttendeeTentative]: 'hiring-dashboard-tasks:tasks.flag.debriefAttendeeTentative',
  [TaskFlagType.DebriefDeclined]: 'hiring-dashboard-tasks:tasks.flag.debriefDeclined',
  [TaskFlagType.InterviewerDeactivated]: 'hiring-dashboard-tasks:tasks.flag.interviewerDeactivated',
  [TaskFlagType.InterviewerTentative]: 'hiring-dashboard-tasks:tasks.flag.interviewerTentative',
  [TaskFlagType.InterviewDeclined]: 'hiring-dashboard-tasks:tasks.flag.interviewerDeclined',
  [TaskFlagType.RequestChange]: 'hiring-dashboard-tasks:tasks.flag.changeRequested',
} satisfies Record<TaskFlagType, string>;

/** Returns the explicit i18n key for every TaskFlag protocol value. */
export const getTaskFlagTranslationKey = (flagType: TaskFlagType): string => {
  const translationKey = TASK_FLAG_TRANSLATION_KEYS[flagType];
  if (!translationKey) {
    logError(`Unknown TaskFlagType "${flagType}"`);
    return 'hiring-dashboard-tasks:tasks.flag.unknown';
  }

  return translationKey;
};

/** Translates a TaskFlag protocol value for compact and detail surfaces. */
export const getTaskFlagLabel = (flagType: TaskFlagType, t: (translationKey: string) => string) => {
  return t(getTaskFlagTranslationKey(flagType));
};
